/**
 *  @since 0.0.1
 */
export function cacheUnaryFunction(f) {
    const mapping = new Map();
    const fres = (key) => {
        const res = mapping.get(key);
        if (res !== undefined) {
            return res;
        }
        else {
            const v = f(key);
            mapping.set(key, v);
            return v;
        }
    };
    return fres;
}
